<template>
  <div>
    <b-row class="mb-1">
      <b-col
        cols="8"
      >
        <b-link
          style="font-size: 24px; color: #fff;"
          to="#"
        > <span> ข้อมูลโครงการ </span>
        </b-link>
      </b-col>
      <b-col
        cols="4"
        class="text-right"
      >
        <b-button
          v-if="userData.username === 'drr'"
          id="toggle-btn"
          v-b-modal="'modalAdd'"
          variant="primary"
          class="btn-add-project"
        >
          <span>
            <feather-icon
              class="text-light"
              icon="PlusCircleIcon"
              size="16"
            />
            เพิ่มโครงการ
          </span>
        </b-button>
      </b-col>
    </b-row>

    <b-card-code>
      <!-- UserEdit.vue -->
      <ProjectForm
        :is-edit-mode="false"
        modal-id="modalAdd"
        @fetch="getProject()"
      />
      <!-- UserAdd.vue -->
      <ProjectForm
        ref="childref"
        :is-edit-mode="true"
        :project-id="selectedProjectId"
        modal-id="modalEdit"
        @fetch="getProject()"
      />
      <!-- -------------- -->
      <b-row>
        <!-- ค้นหา -->
        <b-col
          md="2"
          sm="2"
          lg="2"
          xs="12"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label style="font-size:14px">ค้นหา</label>
          <b-input-group
            style="padding-left:14px; max-width: 150px;"
            size="sm"
          >
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ป้อนคำค้นหา"
              style="background-color:rgba(0,0,0, 0.6);"
              @input="filter = $event || ''"
            />
          </b-input-group>
        </b-col>

        <!-- dropdown ปีงบประมาณ -->
        <b-col
          md="2"
          sm="2"
          lg="2"
          xs="12"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label style="font-size:14px">ปีงบประมาณ</label>
          <b-form-select
            v-model="selectedYear"
            :options="yearOptions"
            size="sm"
            style="background-color:rgba(0,0,0, 0.6); color: white; margin-left:14px; width: 120px;"
            @change="applyFilters"
          />
        </b-col>

        <!-- dropdown หน่วยงาน -->
        <b-col
          md="2"
          sm="2"
          lg="2"
          xs="12"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label style="font-size:14px">หน่วยงาน</label>
          <b-form-select
            v-model="selectedDept"
            :options="deptOptions"
            size="sm"
            style="background-color:rgba(0,0,0, 0.6); color: white; margin-left:14px; width: 120px;"
            @change="applyFilters"
          />
        </b-col>

        <!-- dropdown ผู้รับจ้าง -->
        <b-col
          md="3"
          sm="3"
          lg="3"
          xs="12"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label style="font-size:14px">ผู้รับจ้าง</label>
          <b-form-select
            v-model="selectedVendor"
            :options="vendorOptions"
            size="sm"
            style="background-color:rgba(0,0,0, 0.6); color: white; margin-left:14px; width: 100%; max-width: 200px;"
            @change="applyFilters"
          />
        </b-col>

        <!-- dropdown สถานะค้ำประกัน -->
        <b-col
          md="2"
          sm="2"
          lg="2"
          xs="12"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label style="font-size:14px">สถานะค้ำ</label>
          <b-form-select
            v-model="selectedGuaranteeStatus"
            :options="guaranteeStatusOptions"
            size="sm"
            style="background-color:rgba(0,0,0, 0.6); color: white; margin-left:14px; width: 120px;"
            @change="applyFilters"
          />
        </b-col>
      </b-row>

      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template
            slot="thead-top"
          >
            <th
              colspan="3"
              style="text-align:center;font-size: 14px; background:rgb(0,0,0, 0.6); color: #fff; padding: 8px;"
            >
              โครงการ
            </th>
            <th
              colspan="3"
              style="text-align:center;font-size: 14px; background:rgb(0,0,0, 1); color: #fff; padding: 8px;"
            >
              การรับประกัน
            </th>
            <th
              colspan="2"
              style="text-align:center;font-size: 14px; background:#0056b3; color: #fff; padding: 8px;"
            >
              จัดการ
            </th>
          </template>
          <template #cell(pj_name)="data">
            <div>
              {{ data.item.pj_code }} -
              <b-link
                :to="{ path: `/summary-project?pj_code=${data.item.pj_code}&pj_id=${data.item.pj_id}`}"
                style="text-decoration: underline; color: #13df00d1;"
              >
                <span>{{ data.item.pj_name }}</span>
              </b-link>
            </div>
          </template>
          <template #cell(vendor_name)="data">
            {{ formatVendorName(data.value) }}
          </template>
          <template #cell(deptname)="data">
            {{ formatDeptName(data.value) }}
          </template>
          <template #cell(guarantee_status)="data">
            <b-badge :variant="getGuaranteeStatusVariant(data.item.guarantee_date_end)">
              {{ getGuaranteeStatusText(data.item.guarantee_date_end) }}
            </b-badge>
          </template>
          <template
            #cell(edit)="data"
          >
            <b-link
              @click="editProject(data.item.pj_id)"
            ><b-img
              src="@/assets/images/icons/Edit.svg"
            />
            </b-link>
          </template>
          <template
            #cell(delete)="data"
          >
            <b-link
              @click.prevent="remove(data.item.pj_id, data.item.pj_code)"
            >
              <b-img
                src="@/assets/images/icons/Delete.svg"
              />
            </b-link>
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
      >

        <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
      <!-- <template #code>
        {{ codeFeedbackHelper }}
      </template> -->
    </b-card-code>
  </div>

</template>

<script>
import {
  BTable, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BLink, BCardBody, BButton, BInputGroup,
  BFormInput, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import ProjectForm from './ProjectForm.vue'

export default {
  components: {
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BLink,
    BCardCode,
    BCardBody,
    BButton,
    BInputGroup,
    BFormInput,
    BImg,
    ProjectForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
        // codeFeedbackHelper,
      },
      addData: {
        id: '',
        username: '',
        firstname: '',
        lasttname: '',
        department: '',
        password: '',
        role: '',
      },
      userId: '',
      occupationID: '',
      fields: [
        {
          key: 'vendor_name', label: 'ผู้รับจ้าง', sortable: true, class: 'text-left', thClass: 'text-center',
        },
        {
          key: 'pj_name', label: 'ชื่อโครงการ', sortable: true, class: 'text-left box', thClass: 'text-center',
        },
        {
          key: 'deptname', label: 'หน่วยงาน', sortable: true, class: 'text-left', thClass: 'text-center',
        },
        {
          key: 'guarantee_date_start', label: 'วันเริ่มต้น', sortable: true, class: 'text-center', thClass: 'text-center', thStyle: { background: '#21AF05', color: '#fff' }, tdClass: 'bg-light-success',
        },
        {
          key: 'guarantee_date_end', label: 'วันสิ้นสุด', requiresAdmin: true, class: 'text-center', thClass: 'text-center', thStyle: { background: '#EF5006', color: '#fff' }, tdClass: 'bg-light-warning',
        },
        {
          key: 'guarantee_status', label: 'สถานะค้ำ', class: 'text-center', thClass: 'text-center', thStyle: { background: '#6610f2', color: '#fff' },
        },
        {
          key: 'edit', label: 'แก้ไข', requiresAdmin: true, class: 'text-center', thClass: 'text-center', thStyle: { background: '#0056b3', color: '#fff' }, tdClass: 'action-column',
        },
        {
          key: 'delete', label: 'ลบ', requiresAdmin: true, class: 'text-center', thClass: 'text-center', thStyle: { background: '#0056b3', color: '#fff' }, tdClass: 'action-column',
        },
      ],
      items: [],
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
      selectedYear: '',
      yearOptions: [
        { value: '', text: 'ทั้งหมด' },
      ],
      selectedDept: '',
      deptOptions: [
        { value: '', text: 'ทั้งหมด' },
      ],
      selectedVendor: '',
      vendorOptions: [
        { value: '', text: 'ทั้งหมด' },
      ],
      selectedGuaranteeStatus: '',
      guaranteeStatusOptions: [
        { value: '', text: 'ทั้งหมด' },
        { value: 'หมดค้ำ', text: 'หมดค้ำ' },
        { value: 'อยู่ในค้ำ', text: 'อยู่ในค้ำ' },
        { value: 'ไม่มีข้อมูล', text: 'ไม่มีข้อมูล' },
      ],
      originalItems: [], // เพิ่มตัวแปรเก็บข้อมูลต้นฉบับ
      selectedProjectId: '',
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    validation() {
      return this.userId.length > 4 && this.userId.length < 13
    },
    validationOccupation() {
      return this.occupationID.length > 1
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)

      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  mounted() {
    // Set the initial number of items
    this.getProject()
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getProject() {
      axios
        .post('/tableProject', { groupname: this.userData.groupname, role: this.userData.role })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.originalItems = response.data // เก็บข้อมูลต้นฉบับ
          this.generateYearOptions()
          this.generateDeptOptions()
          this.generateVendorOptions()
        })
    },
    remove(id, code) {
      this.$swal({
        title: '<span style="color:#000000">ต้องการลบข้อมูลหรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            const selectedID = id
            await axios.post('/deleteProject', { pj_id: selectedID, pj_code: code })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">ลบข้อมูลเรียบร้อย.</span>',
              // text: 'Deleted successfully.',
              showConfirmButton: false,
              timer: 1000,
            })
            this.getProject()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' You clicked the button!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    applyFilters() {
      if (!this.selectedYear) {
        // ถ้าไม่ได้เลือกปี (เลือก "ทั้งหมด") ให้แสดงข้อมูลทั้งหมด
        this.items = [...this.originalItems]
        this.totalRows = this.originalItems.length
      } else {
        // กรองข้อมูลตามปีงบประมาณที่เลือก
        this.items = this.originalItems.filter(item => {
          // ตรวจสอบว่ามี guarantee_date_start หรือไม่
          if (!item.guarantee_date_start) return false

          // วันที่อยู่ในรูปแบบ "DD/MM/YYYY" (เช่น "10/04/2568")
          const dateParts = item.guarantee_date_start.split('/')
          if (dateParts.length !== 3) return false

          // ดึงปี พ.ศ. จากส่วนสุดท้ายของวันที่
          const year = dateParts[2]

          // เปรียบเทียบกับปีที่เลือก
          return year === this.selectedYear
        })

        this.totalRows = this.items.length
      }

      if (this.selectedDept) {
        this.items = this.items.filter(item => item.deptname === this.selectedDept)
        this.totalRows = this.items.length
      }

      if (this.selectedVendor) {
        this.items = this.items.filter(item => item.vendor_name === this.selectedVendor)
        this.totalRows = this.items.length
      }

      if (this.selectedGuaranteeStatus) {
        this.items = this.items.filter(item => {
          const guaranteeStatus = this.getGuaranteeStatusText(item.guarantee_date_end)
          return guaranteeStatus === this.selectedGuaranteeStatus
        })
        this.totalRows = this.items.length
      }
    },
    resetYearFilter() {
      this.selectedYear = ''
      this.items = [...this.originalItems]
      this.totalRows = this.originalItems.length
    },
    generateYearOptions() {
      // เริ่มต้นด้วยตัวเลือก "ทั้งหมด"
      const yearOptions = [{ value: '', text: 'ทั้งหมด' }]
      const years = new Set()

      // วนลูปผ่านโครงการทั้งหมดเพื่อดึงปีที่มีอยู่
      this.originalItems.forEach(item => {
        if (item.guarantee_date_start) {
          const dateParts = item.guarantee_date_start.split('/')
          if (dateParts.length === 3) {
            const year = dateParts[2]
            years.add(year)
          }
        }
      })

      // เพิ่มปีที่มีอยู่ลงในตัวเลือก (เรียงจากมากไปน้อย)
      Array.from(years)
        .sort((a, b) => b - a) // เรียงจากมากไปน้อย
        .forEach(year => {
          yearOptions.push({ value: year, text: year })
        })

      // อัปเดตตัวเลือกปีงบประมาณ
      this.yearOptions = yearOptions
    },
    generateDeptOptions() {
      // เริ่มต้นด้วยตัวเลือก "ทั้งหมด"
      const deptOptions = [{ value: '', text: 'ทั้งหมด' }]
      const depts = new Set()

      // วนลูปผ่านโครงการทั้งหมดเพื่อดึงหน่วยงานที่มีอยู่
      this.originalItems.forEach(item => {
        if (item.deptname) {
          depts.add(item.deptname)
        }
      })

      // เพิ่มหน่วยงานที่มีอยู่ลงในตัวเลือก
      Array.from(depts)
        .sort((a, b) => a.localeCompare(b))
        .forEach(dept => {
          // ใช้ฟังก์ชัน formatDeptName เพื่อแสดงชื่อย่อในตัวเลือก
          const formattedDept = this.formatDeptName(dept)
          deptOptions.push({
            value: dept,
            text: formattedDept,
          })
        })

      // อัปเดตตัวเลือกหน่วยงาน
      this.deptOptions = deptOptions
    },
    generateVendorOptions() {
      // เริ่มต้นด้วยตัวเลือก "ทั้งหมด"
      const vendorOptions = [{ value: '', text: 'ทั้งหมด' }]
      const vendors = new Set()

      // วนลูปผ่านโครงการทั้งหมดเพื่อดึงผู้รับจ้างที่มีอยู่
      this.originalItems.forEach(item => {
        if (item.vendor_name) {
          vendors.add(item.vendor_name)
        }
      })

      // เพิ่มผู้รับจ้างที่มีอยู่ลงในตัวเลือก
      Array.from(vendors)
        .sort((a, b) => a.localeCompare(b))
        .forEach(vendor => {
          // ใช้ฟังก์ชัน formatVendorName เพื่อแสดงชื่อย่อในตัวเลือก
          const formattedVendor = this.formatVendorName(vendor)
          vendorOptions.push({
            value: vendor,
            text: formattedVendor,
          })
        })

      // อัปเดตตัวเลือกผู้รับจ้าง
      this.vendorOptions = vendorOptions
    },
    formatVendorName(vendorName) {
      if (!vendorName) return ''

      // ตัดคำว่า "ห้างหุ้นส่วนจำกัด", "บริษัท" และ "จำกัด" ออก
      const shortName = vendorName
        .replace(/ห้างหุ้นส่วนจำกัด\s*/g, '')
        .replace(/บริษัท\s*/g, '')
        .replace(/\s*จำกัด/g, '')
        .trim()

      return shortName
    },
    formatDeptName(deptName) {
      if (!deptName) return ''

      // แทนที่ชื่อหน่วยงานด้วยชื่อย่อ
      const shortName = deptName
        .replace(/สำนักงานทางหลวงชนบท/g, 'สทช.')
        .replace(/แขวงทางหลวงชนบท/g, 'ขทช.')
        .replace(/หมวดบำรุงทางหลวงชนบท/g, 'บทช.')
        .trim()

      return shortName
    },
    getGuaranteeStatusVariant(date) {
      if (!date) return 'light-secondary'

      const today = new Date()

      // แปลงวันที่จากรูปแบบ DD/MM/YYYY (พ.ศ.) เป็น Date object
      const dateParts = date.split('/')
      if (dateParts.length !== 3) return 'light-secondary'

      // แปลงปี พ.ศ. เป็น ค.ศ.
      const day = parseInt(dateParts[0], 10)
      const month = parseInt(dateParts[1], 10) - 1 // เดือนใน JavaScript เริ่มจาก 0
      const yearBE = parseInt(dateParts[2], 10)
      const yearCE = yearBE - 543 // แปลงปี พ.ศ. เป็น ค.ศ.

      const guaranteeDate = new Date(yearCE, month, day)

      if (guaranteeDate < today) {
        return 'light-danger'
      }
      return 'light-success'
    },
    getGuaranteeStatusText(date) {
      if (!date) return 'ไม่มีข้อมูล'

      const today = new Date()

      // แปลงวันที่จากรูปแบบ DD/MM/YYYY (พ.ศ.) เป็น Date object
      const dateParts = date.split('/')
      if (dateParts.length !== 3) return 'ไม่มีข้อมูล'

      // แปลงปี พ.ศ. เป็น ค.ศ.
      const day = parseInt(dateParts[0], 10)
      const month = parseInt(dateParts[1], 10) - 1 // เดือนใน JavaScript เริ่มจาก 0
      const yearBE = parseInt(dateParts[2], 10)
      const yearCE = yearBE - 543 // แปลงปี พ.ศ. เป็น ค.ศ.

      const guaranteeDate = new Date(yearCE, month, day)

      if (guaranteeDate < today) {
        return 'หมดค้ำ'
      }
      return 'อยู่ในค้ำ'
    },
    editProject(pjId) {
      this.selectedProjectId = String(pjId)
      this.$nextTick(() => {
        this.$bvModal.show('modalEdit')
      })
    },
  },
}
</script>

    <style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .box {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
    color: black;
    // font-weight: bold;
}
    .dropdown-item {
      white-space: normal !important;
      word-wrap: break-word !important;
      padding: 0.5rem 1rem !important;
    }
    .action-column {
      width: 40px;
      padding: 0.25rem !important;
    }
    .btn-add-project {
      min-width: 150px;
      padding: 0.5rem 1rem;
      font-weight: 500;
    }
    </style>
